// extracted by mini-css-extract-plugin
export default {"cards":"cards-module--cards--2Ikoq","card":"cards-module--card--3qSxT","link":"cards-module--link--K91dH"};